import React, { useState } from 'react';

function Videos({ VideosContent, LanguageSelected, t, divstyle }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevVideo = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : VideosContent.length - 1
        );
    };

    const goToNextVideo = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex < VideosContent.length - 1 ? prevIndex + 1 : 0
        );
    };
    const getText = (textObj) => {
        if (!textObj) return '';
        if (typeof textObj === 'object' && textObj !== null) {
            return textObj[LanguageSelected] || '';
        }
        return textObj || '';
    };

    const hasValidContent = (video) => {
        const VideoDescription = getText(video.description);
        return VideoDescription.trim() !== '';
    };
    if (!VideosContent || VideosContent === 0) return null;
    const validVideos = VideosContent.filter(hasValidContent);
    if (validVideos.length === 0) return null;
    
    return (
        <div>
            <div className={`${divstyle} ${LanguageSelected === 'ar' ? 'erlDiv' : ''}pt-5 pl-3 pr-3`}>
                <div className="pb-2 ">
                    <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-2.5' : 'title left-2 title--h1 first-title title__separate text-theme'}`}>{t("Vidéos")}</h1>
                </div>
            </div>
             <div className="grid grid-cols-1 js-masonry   js-filter-container">
                                <div className="gutter-sizer " />
                                {/* Item 1 */}
                                {
                                    VideosContent &&
                                    <>

                                        <div className="relative col-12">

                                            <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">

                                                {VideosContent.map((_, i) => (
                                                    <span
                                                        key={i}
                                                        className={`block h-1  cursor-pointer rounded-2xl transition-all content-[''] ${currentIndex === i ? "bg-gray-300 w-8" : "bg-gray-300 w-4"
                                                            }`}
                                                        onClick={() => setCurrentIndex(i)}
                                                    />
                                                ))}

                                            </div>
                                            <div className="carousel-container relative">
                                                <div className="carousel-wrapper">
                                                    {validVideos.map((video, index) => {
                                                       const videoDescription = getText(video.description);
                                                       return(
                                                        <div
                                                            key={index}
                                                            className={` category-concept pl-3 pr-3 ${currentIndex === index ? "" : "hidden"}`}>
                                                            {video.Platform === 'Youtube' &&
                                                                <div >
                                                                    <iframe className='rounded-xl w-full videoclass' src={`https://www.youtube.com/embed/${video.URL}`} frameborder="0" allowfullscreen></iframe>
                                                                </div>
                                                            }
                                                            {video.Platform === 'Viemo' &&
                                                                <div >
                                                                    <iframe className='rounded-xl w-full videoclass' src={`https://player.vimeo.com/video/${video.URL}`} frameborder="0" allowfullscreen></iframe>
                                                                </div>
                                                            }
                                                            <div className="gallery-grid__caption mt-2 mb-2">
                                                                <span className="text-about text-theme">{videoDescription}</span>
                                                            </div>

                                                        </div>
                                                       )
                                                        
})}
                                                </div>
                                                {
                                                    VideosContent &&
                                                    <>
                                                        <a
                                                            className={`text-gray-300 cursor-pointer absolute -left-4 ml-0.5 next-icon-video hover:text-gray-500`}
                                                            onClick={goToPrevVideo}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                                            </svg>

                                                        </a>
                                                        <a
                                                            className="text-gray-300 cursor-pointer absolute  -right-4 mr-0.5  absolute next-icon-video hover:text-gray-500"
                                                            onClick={goToNextVideo}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                                            </svg>

                                                        </a>
                                                    </>
                                                }


                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
        </div>
    )
}

export default Videos;
